"use client";
import { useEffect, useState } from 'react';

import { useLanguage } from "@/app/utils/LanguageContext";
import "./index.scss";
import Footer from "@/app/ui/footer";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";

import dayJS, { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import { getJKCScheduledRides, getBusinessDate } from "@/app/utils/request/requestList";
import _ from 'lodash';
import moment from "moment";
import { getAssetPrefix, getFOStageResult, getSearchParams, RaceState, PoolState, adobeData, updateMetaTag, MeetingState, paddingNum, getCurrentTimeFormatted} from "@/app/utils/Common";
import NoInformation from "../Common/NoInformation";
import dayjs from "dayjs";
import Remarks from "../Common/remarks"; 
import { pageSet } from "@/app/utils/pageSet"; 

const JKCScheduledRides: React.FC = () => {

  const { state: lang } = useLanguage();

  const [remarkIT, setRemarkIT] = useState<any>(null);
  const [remarkUser, setRemarkUser] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [mockData, setMockData] = useState<any>(null);
  const [stage, setStage] = useState(0);
  const [loading, setloading] = useState(true);
  const assetPrefix = getAssetPrefix();
  const [bizdate, setbizdate] = useState("");
  const { racedate } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));
  const [allAbandonInd, setAllAbandonInd] = useState(true);
  const [jockeyStat, setjockeyStat] = useState<any>(null);

  const { t, langCode } = lang;

  // let hasData = 1;  2: noinfo  
  const [hasData, setHasData] = useState(1);

  //get CMS Data
  useEffect(() => {
    updateMetaTag(langCode, pageSet.jkcscheduledrides);
    adobeData(langCode, "pageview", {
      pageId: "racing/local",
    });

    getBusinessDate().then((res: any) => {
      if(!res)
      {
        setHasData(2);
        setloading(false);
        return;
      } 
      const resbizdate: string = res?.timeOffset?.ts?.substring(0, res?.timeOffset?.ts?.indexOf('+'));

      const regex = /^\d{4}\/\d{2}\/\d{2}$/;
      console.log(resbizdate, "resbizdate------------")
      if (regex.test(racedate) && dayjs(racedate).isBefore(resbizdate)) {
        console.log(resbizdate, "resbizdate isBefore------------")
        setHasData(2);
        setloading(false);
      } else {
        setbizdate(resbizdate);
      }
    })
  }, [])
  //get QIDS Data
  useEffect(() => { 
    if (!bizdate) return
      
    const date = handleDate(racedate, dateFormat.qids.dateWithoutTimezone)
    getJKCScheduledRides("")
      .then(async (res: any) => { 
        if(!res)
        {
          setHasData(2);
          setloading(false);
          return;
        } 
        const resmeeting = res?.commonMeetings?.filter((x: any) => MeetingState("DECLARED").includes(x.status)) //res?.commonMeetings;

        if (!resmeeting || resmeeting?.length == 0) {
          if (!racedate) setHasData(3);
          else setHasData(2)
          return;
        }

        const commonMeetings = _.orderBy(resmeeting, ["date"])
        let curMtg = null;
        if (racedate) {
          curMtg = commonMeetings?.find((x: any) => x?.date == date)
          if (!curMtg) {
            setHasData(2);
            return;
          }
        } else {
          curMtg = commonMeetings?.[0]
        }
        setData(curMtg)
        
        // let resStage = 0
        // getFOStageResult(curMtg?.date, "JKC").then((resStg: any) => {
        //   resStage = 5//resStg
        //   setStage(resStage);
        // });
        const resStage = await getFOStageResult(curMtg?.date, "JKC")  
        setStage(resStage);

        console.log("resStage", resStage, res) 
           
        const foPool = _.orderBy(curMtg?.foPools, ["instNo"]).findLast((x: any) => x.instNo);
        const raCompositions = foPool?.includeRaces ?? [];
        const raceClassList = mapRaceClassList(curMtg)
           
        //const dd = MeetingState(curMtg?.status) && curMtg?.pmPools
        const otherSelNo = foPool?.otherSelNo ?? 0;
        const poolRefund = PoolState("REFUND").includes(foPool?.status);
        const currentRaceNo = _.orderBy(curMtg?.races, ["no"])?.findLast((x: any) => RaceState("CLOSED").includes(x.status))?.no;

        const resjockeyStat = res?.jockeyStat || [];
        const changeHistories = curMtg?.changeHistories;
        if (resStage < 3) { 
          const pmPool = curMtg?.pmPools;
          const notIncludesStatus = ["Standby", "Scratched"]; 
          const jockeyList = [] as any;
 
          curMtg?.races?.forEach((ele: any) => {  
            ele?.runners?.filter((x: any) => (x.no || x.standbyNo) && x.status !="Standby" && x?.jockey?.name_en.trim() != "")?.forEach((ele2: any) => {

              //const isChg96 = changeHistories?.filter((c: any) => c.type == "96" && c.scratchHorseId == ele2?.horse?.id && c.raceNo == ele?.no)
              //if(isChg96 && isChg96.length > 0) return;
             
              const targetJockey = jockeyList.find((i: any) => i?.jockeyCode == ele2?.jockey?.code)
              // new jockey
              //const changeJockey = changeHistories?.find((x: any) => x.type == "99" && x.runnerNo == ele2?.no && x.raceNo == ele?.no);
              const targetWinOdds = pmPool?.find((i: any) => i?.leg?.number == ele?.no)?.oddsNodes?.find((ii: any) => parseInt(ii?.combString) == ele2?.no)?.oddsValue || "";
 
              if (!targetJockey) { 
                  jockeyList.push({
                    jockeyCode: ele2?.jockey?.code,
                    jockeyName: lang.langCode == "en-us" ? ele2?.jockey?.name_en : ele2?.jockey?.name_ch,
                    jockeyName_en: ele2?.jockey?.name_en,
                    jockeyHorseList: [{
                      id: ele2?.horse?.id,
                      horseName: lang.langCode == "en-us" ? ele2?.horse?.name_en : ele2?.horse?.name_ch,
                      horseCode: ele2?.horse?.code,
                      // winOdds: ele2?.winOdds,
                      winOdds: targetWinOdds == "---" ?  0 : Number(targetWinOdds ?? 0),
                      raceNo: ele?.no,
                      status: ele2?.status,
                      //changeJockey: changeJockey ? true : false,
                    }],
                  }) 
              } else {
                targetJockey?.jockeyHorseList?.push({
                  id: ele2?.horse?.id,
                  horseName: lang.langCode == "en-us" ? ele2?.horse?.name_en : ele2?.horse?.name_ch,
                  // winOdds: ele2?.winOdds,
                  winOdds: targetWinOdds == "---" ? 0 : Number(targetWinOdds ?? 0),
                  horseCode: ele2?.horse?.code,
                  raceNo: ele?.no,
                  status: ele2?.status,
                  //changeJockey: changeJockey ? true : false,
                })
              }
            });
          });
          console.log("[jockeyList----------]", jockeyList)
          const initStatValue = {
            numFirst: 0,
            numSecond: 0,
            numThird: 0,
            numFourth: 0,
            numFifth: 0,
            numStarts: 0,
          }
          jockeyList.forEach((ele: any) => {
            const tarEle = resjockeyStat?.find((i: any) => i?.code == ele?.jockeyCode); 
            if (tarEle) {
              ele.dhStat  = tarEle?.dhStat?.find((x: any) => x?.ven?.toUpperCase() == "ALL") || initStatValue;
              ele.ssnStat = tarEle?.ssnStat?.find((x: any) => x?.ven?.toUpperCase() == "ALL") || initStatValue;
            } else {
              ele.dhStat  = initStatValue;
              ele.ssnStat = initStatValue;
            }
          });

          const tempSort = _.orderBy(jockeyList, 
            ["ssnStat.numFirst", "dhStat.numFirst", 
            "ssnStat.numSecond", "dhStat.numSecond", 
            "ssnStat.numThird", "dhStat.numThird",
            "ssnStat.numFourth", "dhStat.numFourth",
            "ssnStat.numFifth", "dhStat.numFifth",
            "ssnStat.numStarts",
            "jockeyName_en"
          ], 
          ["desc", "asc",
          "desc", "asc",
          "desc", "asc",
          "desc", "asc", 
          "desc", "asc", 
          "asc",
          "asc",
          ])

          // const tempSort1 = jockeyList.sort((a:any, b:any) => {
          //   if (a?.ssnStat && b?.ssnStat) {
          //     if (b?.ssnStat?.numFirst !== a?.ssnStat?.numFirst) {
          //       return b?.ssnStat?.numFirst - a?.ssnStat?.numFirst; 
          //     } 
          //     if (a?.dhStat?.numFirst !== b?.dhStat?.numFirst) {
          //       return a?.dhStat?.numFirst - b?.dhStat?.numFirst; 
          //     }
          //     if (b?.ssnStat?.numSecond !== a?.ssnStat?.numSecond) {
          //       return b?.ssnStat?.numSecond - a?.ssnStat?.numSecond; 
          //     }
          //     if (a?.dhStat?.numSecond !== b?.dhStat?.numSecond) {
          //       return a?.dhStat?.numSecond - b?.dhStat?.numSecond; 
          //     }
          //     if (b?.ssnStat?.numThird !== a?.ssnStat?.numThird) {
          //       return b?.ssnStat?.numThird - a?.ssnStat?.numThird; 
          //     }
          //     if (a?.dhStat?.numThird !== b?.dhStat?.numThird) {
          //       return a?.dhStat?.numThird - b?.dhStat?.numThird; 
          //     }
          //     if (b?.ssnStat?.numFourth !== a?.ssnStat?.numFourth) {
          //       return b?.ssnStat?.numFourth - a?.ssnStat?.numFourth; 
          //     }
          //     if (a?.dhStat?.numFourth !== b?.dhStat?.numFourth) {
          //       return a?.dhStat?.numFourth - b?.dhStat?.numFourth; 
          //     }
          //     if (b?.ssnStat?.numFifth !== a?.ssnStat?.numFifth) {
          //       return b?.ssnStat?.numFifth - a?.ssnStat?.numFifth; 
          //     }
          //     if (a?.dhStat?.numFifth !== b?.dhStat?.numFifth) {
          //       return a?.dhStat?.numFifth - b?.dhStat?.numFifth; 
          //     }
          //     if (a?.ssnStat?.numStarts !== a?.ssnStat?.numStarts) {
          //       return a?.ssnStat?.numStarts - b?.ssnStat?.numStarts; 
          //     }
          //   } 
          //   return a?.jockeyName_en.localeCompare(b?.jockeyName_en, 'en', {sensitivity: "base"})
          // });

          setjockeyStat(tempSort);

          const jkcForTheDayData = {
            NextMeetingDate: curMtg?.date,
            Stage: resStage,
            RaceHeaders: mapRaceHeaders(_.orderBy(resmeeting, ["date"])), 
            RaceClassList: raceClassList,
            CurrentRaceNo: currentRaceNo ?? 0,
            AllRacesNoPool: MeetingState("DEFINED").includes(curMtg.status) && curMtg.totalNumberOfRace == curMtg.raNoPlCount
            //JockeysRidesList : jockeyList.sort((a:any, b:any) => a?.jockeyName.localeCompare(b?.jockeyName, 'en', {sensitivity: "base"}))
          } 
          setAllAbandonInd(raceClassList?.filter((x: any) => x.AbandonInd > 0)?.length == raceClassList?.length)
          setMockData(
            jkcForTheDayData
          )
          console.log("MockData", jkcForTheDayData, jockeyList)
          return;
        }


        const challengeList = mapChallenges(curMtg, foPool, raCompositions, resStage, poolRefund, changeHistories);
        let jockeysRidesList = challengeList;
        let othersList = [] as any;
        console.log("othersList", otherSelNo, challengeList)
        if (otherSelNo > 0 && challengeList?.length > 0) { 
          othersList = _.orderBy(challengeList?.filter((x: any) => otherSelNo == x.SelNo), ["Points", "name_en"], ["desc", "asc"]);
          console.log("othersList", othersList)
          const other = othersList?.[0]
          jockeysRidesList = challengeList.filter((x: any) => x.SelNo != otherSelNo).concat({ SelNo: otherSelNo, Points: other?.Points ?? 0, Odds: other?.Odds ?? 0 })
         
        }  
        console.log("resStage", jockeysRidesList, sortedChallengeList(jockeysRidesList))
        jockeysRidesList = resStage > 4 ? sortedChallengeList(jockeysRidesList) : _.orderBy(jockeysRidesList, ["SelNo"])
        console.log("resStage", resStage, jockeysRidesList, hasData)
        const poolName = lang.langCode == "en-us" ? foPool?.oddsTypeDes.english : foPool?.oddsTypeDes.chinese;
        const jockeyData = {
          NextMeetingDate: curMtg?.date,
          PoolName: poolName?.replace("{0}", foPool?.instNo) ,
          PoolNumber: foPool?.instNo,
          Stage: resStage,
          RaceHeaders: mapRaceHeaders(_.orderBy(resmeeting, ["date"])),
          //RaceClassList: raceClassList,
          RaceClassList: raceClassList?.filter((x: any) => raCompositions?.includes(x.RaceNo)),
          PoolRefund: poolRefund,
          OtherNo: otherSelNo,
          CurrentRaceNo: currentRaceNo ?? 0,
          InplayUpToRaceNo: foPool?.inplayUpTo,
          JockeysRidesList: jockeysRidesList,
          OthersList: othersList
        }
        setMockData(
          jockeyData
        )
        console.log("getJKCScheduledRides", res?.commonMeetings, jockeysRidesList)

        console.log("MockData", jockeyData)

        setData(_.orderBy(resmeeting, ["date"]));

      })
      .catch((e: any) => {
        console.log(e);
      }).finally(() => {
        setloading(false)
      });
  }, [bizdate])

  const sortedChallengeList = (challengeList: any) => { 
    return challengeList.sort((a: any, b: any) => {
      const aOddsCondition = Number(a.Odds ?? 0) < 1;
      const bOddsCondition = Number(b.Odds ?? 0) < 1;
      if (aOddsCondition !== bOddsCondition) {
        return (aOddsCondition ? 1 : 0) - (bOddsCondition ? 1 : 0);
      } 

      if (a.Odds !== b.Odds) {
        return a.Odds - b.Odds;
      }

      const aPoints = Number(a.Odds ?? 0) < 1 ? 0 : a.Points;
      const bPoints = Number(b.Odds ?? 0) < 1 ? 0 : b.Points;
      if (aPoints !== bPoints) {
        return bPoints - aPoints;
      }

      return a.SelNo - b.SelNo;
    });
  }
  const mapRaceHeaders = (mtg: any) => {
    const raceHeaders = mtg.map((item: any) => {
      return {
        Venue: item.venueCode,
        Date: item.date,
        Racecourse: lang.langCode == "en-us" ? item.venueDes.english : item.venueDes.chinese 
      }
    });

    return raceHeaders;
  }

  const mapRaceClassList = (mtg: any) => {

    const RaceClassList = mtg?.races?.map((race: any) => {

      const raceVoid = RaceState("REFUND").includes(race?.status?.toUpperCase());
      // RaceState("RESULT").includes(race.status) [race.status]  => RaRes
      const resultInd = RaceState("RESULT").includes(race?.status) || "RESULT" == race?.status?.toUpperCase();
      const mp = mtg?.pmPools?.filter((x: any) => Number(x.leg.races?.[0] ?? 0) == Number(race.no ?? 0))?.find((x: any) => PoolState("REFUND").includes(x.status?.replaceAll("_", "")));

      return {
        RaceNo: race.no,
        RaceClass: race.claCode,
        Distance: race.distance,
        status: race.status,
        Track: lang.langCode == "en-us" ? race.raceTrack2.description_en : race.raceTrack2.description_ch,
        AbandonInd: raceVoid ? MapAbandonRaceInd(race?.status?.toUpperCase()) : (!resultInd && mp) ? 1 : 0
      }
    })

    return RaceClassList;
  }
 
  const mapChallenges = (mtg: any, foPool: any, raCompositions: any, stage: number, poolRefund: boolean, changeHistories: any) => {
    let jockeyList = [] as any;
    const xResSheetsRes = (foPool?.resultSheet as [])?.concat( foPool?.otherResultSheet as []);  // [{...foPool?.resultSheet, ...foPool?.otherResultSheet}];
   
    // const foRes = foPool?.resultSheet?.map((x: any) => {return x?.result?.[0]})
    // const foOthRes = foPool?.otherResultSheet?.map((x: any) => {return x?.otherResult})
    // const xResSheetsResALL = foRes?.concat(foOthRes?.[0])?.filter((x: any) => x?.raIncidents?.length > 0);  // [{...foPool?.resultSheet, ...foPool?.otherResultSheet}];
  
    const filterRace = mtg?.races?.filter((x: any) => raCompositions?.length > 0 && raCompositions?.includes(x.no))
    const races = _.orderBy(filterRace, ["no"])

    const xRaIncidents = handleResSheets(xResSheetsRes)
    console.log("get foPool xRaIncidents",xRaIncidents)

    races?.forEach((race: any) => {
      race?.runners?.forEach((run: any) => {
        // const isChg96 = changeHistories?.filter((c: any) => c.type == "96" && c.runnerNo == run?.no && c.raceNo == race?.no)
        // console.log("runners",  run.status, run.jockey.name_en)
        // if(isChg96 && isChg96.length > 0) return; 
        let selNo = 0
        let orderNo = 0
        let xRes = null as any; 

        // xResSheetsRes?.forEach((r: any) => { 
        //   if(!xRes){
        //     xRes = r.result?.find((x: any) => x.refId == run.jockey.code)
        //     if(!xRes)
        //       xRes = r.otherResult?.find((x: any) => x.refId == run.jockey.code)
            
        //     if(xRes)
        //       selNo = Number(r.selStr ?? 0);  orderNo = Number((xRes?.selOdrNo ?? xRes?.orderNo) ?? 0); 
        //   }  
        // }) 
       
        xRes = xRaIncidents?.filter((x: any) => x.refId == run.jockey.code)
        selNo = xRes[0]?.selStr ?? 0
        if(selNo > 0){
          //console.log("get foPool xRaIncidents",xRaIncidents)
          let startersList = [] as any
          races?.forEach((r: any) => {

            const ruJ = r?.runners?.find((x: any) => (x.no || x.standbyNo) &&  x.status != "Standby" && x.jockey.name_en.trim() == run.jockey.name_en.trim());
            //console.log("race", ruJ)
            if (ruJ) {
              //const isChg96 = ?.filter((c: any) => c.type == "96" && c.scratchHorseId == ruJ?.horse?.id && c.raceNo == r?.no)
              //console.log("runners",  run.status, run.jockey.name_en)
              //if(isChg96 && isChg96.length > 0) return;

            
              //const xRaInc = xRes?.raIncidents?.filter((x: any) => x.raceNo == r.no)?.find((x: any) => x.horseId == ruJ?.horse?.id);
              const xRaInc = xRes?.find((x: any) => x.raceNo == r.no && x.horseId == ruJ?.horse?.id);
              
              const raIncTyp = xRaInc?.raIncidentType ?? ""; // xRaInc?.raIncTyp;
            
              // let changeJockey = {} as any;
              // xResSheetsResALL.forEach((raIn: any) => {
              //   const curRaIn = raIn.raIncidents?.filter((x: any) => x.raceNo == r.no)?.find((x: any) => x.horseId == ruJ?.horse?.id);
              //   if(curRaIn) changeJockey = curRaIn
              // });
              //const changeJockey = xResSheetsResALL?.raIncidents?.filter((x: any) => x.raceNo == r.no)?.find((x: any) => x.horseId == ruJ?.horse?.id);
              const changeJockey = xRaIncidents?.find((x: any) => x.raceNo == r.no && x.horseId == ruJ?.horse?.id);
              
              //const changeJockey = mtg?.changeHistories?.find((x: any) => x.type == "99" && x.runnerNo == ruJ?.no && x.raceNo == r?.no);
              const poolStat = mtg?.pmPools?.find((x: any) => x.leg?.races?.[0] == r.no);
            
              const oddsNodes = poolStat?.oddsNodes?.find((x: any) => x.combString == paddingNum(ruJ?.no).toString());
                
              const starters = {
                //x.firstLegRaId == r.raceId 
                WinOdds: (poolRefund || "2" == raIncTyp || mtg?.pmPools?.length < 0) ? 0 : (oddsNodes?.oddsValue != "---" ? Number(oddsNodes?.oddsValue ?? 0) : 0),
                ChangeJockeyType: (changeJockey && "1" == (changeJockey?.raIncidentType ?? "")) ? true : false, //changeJockey ? true : false
                RaceNo: r.no,
                Points: (stage < 5 || poolRefund || "2" == raIncTyp || !xRes) ? 0 : (xRaInc?.points ?? 0),
                Horse: {
                  Id: ruJ.horse?.id, 
                  Name: lang.langCode == "en-us" ? ruJ.horse?.name_en : ruJ.horse?.name_ch
                },
                ScratchedInd: "3" == (raIncTyp) || ("Scratched" == (ruJ.status) || "ScratchedReserved" == (ruJ.status))
              } 
              startersList.push(starters)
            }

          })
         
          const resultJ = {
            Id: run.jockey.code,
            code: run.jockey.code,
            name_en: run.jockey?.name_en.trim(),
            Name: lang.langCode == "en-us" ? run.jockey?.name_en.trim() : run.jockey.name_ch.trim(),
            SelNo: selNo,
            Points: stage < 5 ? 0 : Number(xRes?.[0]?.accumulatedPoints) ?? "---",//(xRes?.raIncidents?.[0]?.points ?? 0) ?? "---", //xRes.accPt
            Odds: foPool?.selections?.find((x: any) => x.combId == selNo)?.currentOddsValue ?? "",
            Starters: startersList
          }
          if (!jockeyList.find((x: any) => x.name_en == run.jockey?.name_en.trim()) && resultJ.Starters.filter((x: any) => x?.Horse.Name?.length > 0).length > 0) {
            jockeyList.push(resultJ);
          }
        }
      })
    })

    return jockeyList;
  }  

  const handleResSheets = (xResSheetsRes: any) => {
    let xRaIncidents = [] as any;
    xResSheetsRes?.forEach((r: any) => { 
      if(r?.result){
        r?.result?.forEach((res: any) => { 
          if(res?.raIncidents){
            res?.raIncidents?.forEach((xRaIn: any) => {
              xRaIncidents.push({
                isOther: false,
                refId: res?.refId,
                horseId: xRaIn?.horseId,
                points: xRaIn?.points,
                raIncidentType: xRaIn?.raIncidentType,
                raceNo: xRaIn?.raceNo,
                accumulatedPoints: res?.accumulatedPoints, 
                selOdrNo: res?.selOdrNo,
                selStr: Number(r?.selStr ?? 0) 
              })
            })
          }else {
            xRaIncidents.push({
              isOther: false,
              refId: res?.refId, 
              accumulatedPoints: res?.accumulatedPoints, 
              selOdrNo: res?.selOdrNo,
              selStr: Number(r?.selStr ?? 0) 
            })
          }
        })
      }else if(r?.otherResult){
        r?.otherResult?.forEach((othR: any) => { 
          if(othR?.raIncidents){
            othR?.raIncidents?.forEach((xRaIn: any) => { 
              xRaIncidents.push({
                isOther: true,
                refId: othR?.refId,
                horseId: xRaIn?.horseId,
                points: xRaIn?.points,
                raIncidentType: xRaIn?.raIncidentType,
                raceNo: xRaIn?.raceNo,
                accumulatedPoints: othR?.accumulatedPoints, 
                orderNo: othR?.orderNo,
                selStr: Number(r?.selStr ?? 0) 
              }) 
            })
          }else {
            xRaIncidents.push({
              isOther: true,
              refId: othR?.refId, 
              accumulatedPoints: othR?.accumulatedPoints, 
              orderNo: othR?.orderNo,
              selStr: Number(r?.selStr ?? 0) 
            }) 
          }
        })
      }
    })
    return xRaIncidents;
  }

  const MapAbandonRaceInd = (raSt: string) => {
    return "ABANDONED" == raSt ? 2 : "VOIDED" == raSt ? 1 : 0;

  }
  const mockData1 = {
    NextMeetingDate: "2023-07-05",
    PoolName: "JOCKEY CHALLENGE 1",
    Stage: 4,
    CurrentRaceNo: 2,
    InplayUpToRaceNo: 1,
    PoolRefund: 1,
    OtherNo: 2,
    RaceHeaders: [
      {
        Venue: "HV",
        Date: "2023-07-05",
        Racecourse: "Happy Valley"
      },
      {
        Venue: "HV",
        Date: "2023-07-06",
        Racecourse: "Happy Valley"
      }
    ],
    JockeysRidesList: [
      {
        Starters: [
          {
            WinOdds: 0,
            ChangeJockeyType: false,
            RaceNo: 1,
            Horse: {
              Id: "HK_2005_G634",
              BrandNo: "G634",
              Name: "SEIHALI"
            },
            ScratchedInd: false
          },
          {
            WinOdds: 0,
            ChangeJockeyType: false,
            RaceNo: 2,
            Horse: {
              Id: "HK_2014_T385",
              BrandNo: "T385",
              Name: "WINASWEWISH"
            },
            ScratchedInd: false
          },
          {
            WinOdds: 0,
            ChangeJockeyType: false,
            RaceNo: 3,
            Horse: {
              Id: "HK_2016_A170",
              BrandNo: "A170",
              Name: "MAGIC LEGEND"
            },
            ScratchedInd: false
          },
          {
            WinOdds: 0,
            ChangeJockeyType: false,
            RaceNo: 4,
            Horse: {
              Id: "HK_2016_A211",
              BrandNo: "A211",
              Name: "SIGHT LEADER"
            },
            ScratchedInd: false
          },
          {
            WinOdds: 0,
            ChangeJockeyType: false,
            RaceNo: 6,
            Horse: {
              Id: "HK_2016_A148",
              BrandNo: "A148",
              Name: "MEGA HEART"
            },
            ScratchedInd: false
          },
          {
            WinOdds: 0,
            ChangeJockeyType: false,
            RaceNo: 7,
            Horse: {
              Id: "HK_2015_V142",
              BrandNo: "V142",
              Name: "CALIFORNIA LEGEND"
            },
            ScratchedInd: false
          }
        ],
        Id: "MUA",
        Name: "A Munro",
        SelNo: 1,
        Points: 0,
        Odds: 0,
      },
    ],
    RaceClassList: [
      {
        RaceNo: 1,
        RaceClass: "G1",
        Distance: 1600,
        Track: "TURF",
        AbandonInd: 2
      },
      {
        RaceNo: 2,
        RaceClass: "3",
        Distance: 1650,
        Track: "TURF",
        AbandonInd: 2
      },
      {
        RaceNo: 3,
        RaceClass: "2",
        Distance: 1000,
        Track: "TURF",
        AbandonInd: 2
      },
      {
        RaceNo: 4,
        RaceClass: "3",
        Distance: 1650,
        Track: "TURF",
        AbandonInd: 2
      },
      {
        RaceNo: 5,
        RaceClass: "3",
        Distance: 1200,
        Track: "TURF",
        AbandonInd: 2
      },
      {
        RaceNo: 6,
        RaceClass: "3",
        Distance: 1800,
        Track: "TURF",
        AbandonInd: 2
      },
      {
        RaceNo: 7,
        RaceClass: "2",
        Distance: 1200,
        Track: "TURF",
        AbandonInd: 2
      },
      {
        RaceNo: 8,
        RaceClass: "2",
        Distance: 1600,
        Track: "TURF",
        AbandonInd: 2
      }
    ],
    OthersList: [
      {
        Name: "",
        Points: 1,
        Odds: 0,
        Starters: [
          {
            RaceNo: 1,
            Horse: {
              Id: "HK_2005_G634",
              BrandNo: "G634",
              Name: "SEIHALI"
            },
          }
        ]
      }
    ]

  }

  const handleRaceHeader = (date: string, racecourse: string) => {

    const curDate = lang.langCode == "en-us" ?
      `${new Date(date).getDate()} ${new Date(date).toLocaleString(lang.langCode, { month: "short" })}`
      : `${new Date(date).toLocaleString(lang.langCode, { month: "short" })}${new Date(date).getDate()}日 `;

    return mockData?.NextMeetingDate == date ?
      <a className="blueBtn1"> {curDate} - {t(racecourse)}</a>
      :
      <a className="greyBtn" href={`?racedate=${moment(date).format('YYYY/MM/DD')}`}>{curDate} - {t(racecourse)}</a>
  }

  const handleDate = (date: string, format: string) => {
    return formattedDate(toDate(date, format), format)
  }

  const handleStatus = () => {
    let msg = "";
    switch (mockData?.Stage) {
      case 4:
        {
          const poolNumber = ""; //System.Text.RegularExpressions.Regex.Match(Model.PoolName, @"\d+").Value;
          msg = t("stage_4").replace("{0}", mockData?.PoolNumber);
        }
        break;
      case 5:
        if (mockData?.CurrentRaceNo > 0) {
          msg = t("stage_5_1").replace("{0}", mockData?.CurrentRaceNo?.toString()).replace("{1}", mockData?.InplayUpToRaceNo?.toString());
        } else {
          msg = t("stage_5_2").replace("{0}", mockData?.InplayUpToRaceNo?.toString());
        }
        break;
      case 6:
        {
          const poolNumber = ""; // System.Text.RegularExpressions.Regex.Match(Model.PoolName, @"\d+").Value;
          msg = t("stage_6").replace("{0}", mockData?.PoolNumber);
        }
        break;
    }
    return msg;
  }

  const handleJKCForTheDayStatus = () => {
    let msg = "";
    
    if (allAbandonInd && mockData?.AllRacesNoPool) {
      msg = t("JKC_allAbandonInd_allRacesNoPool");
    }
    else if (allAbandonInd) {
      msg = t("JKC_allAbandonInd");
    }
    else if (mockData?.AllRacesNoPool) {
      msg = t("JKC_allRacesNoPool");
    }
    else {
      msg = t("JKC_other");
    }
    return msg;
  }

  const handleTbodyStarters = (jockey: any, raceNo: number, ids: number) => {

    let runner = jockey?.Starters?.filter((s: any) => s.RaceNo == raceNo)?.[0]

    return (
      <td className={runner?.ChangeJockeyType ? " tdBgPurple" : ""} key={`${jockey.name}_${raceNo}_${ids}`} >
        {runner?.ScratchedInd ?
          <span className="color_grey1">{t("SCR")}<br />{runner.Horse.Name}</span>
          :
          <>
            {
              raceNo > mockData.CurrentRaceNo && runner.WinOdds > 0 ?
                <><span className="color_red5">{runner.WinOdds >= 10 ? runner.WinOdds : runner.WinOdds}</span><br /></>
                : null
            }
            <a href={`/${lang.langCode}/local/information/horse?horseid=${runner.Horse.Id}`}>{runner.Horse.Name}</a>
            {
              raceNo <= mockData.CurrentRaceNo && runner.Points > 0 ?
                <><br /><span className="color_red5">({runner.Points})</span></>
                : null
            }
          </>

        }
      </td >
    )
  }
   
  const JKCForTheDayTable = () => {
 
    return (
      <table className="jkc_table titleHoverColorPurple margin_top10 table_bd f_tac f_fs13" style={{ width: "100%" }}>
        <thead>
          <tr className="bg_blue font_wb color_w">
            <td width="80">{t("jockey")}</td>
            <td width="110">{t("currentSeasonScore")}</td>
            {/* {raceMeetings.map((race: any, indx: any) => <th key={indx} className="f_tac bg_blue" style={{ width: 70 }}>{renderRaceNoColumn(race?.no)}</th>)
            } */}

            {
              mockData?.RaceClassList?.map((race: any, i: number) => (
                <td key={`raceClass_thead_1_${i}`} style={{width: "auto"}} className="f_tac bg_blue">
                  {t("jkc_thead_race").replace("{0}", race.RaceNo.toString())}</td>
              ))
            }
          </tr>
          <tr className="tdBgYellow tdAlignC f_fs13">
            <td style={{whiteSpace: "nowrap"}}> 
              {t("Race_Class")}<br />
              {t("Dist.")}<br />
              {t("Track")}</td>
            <td className="tdAlignVC">
              <div style={{ display: "table", width: "110px", tableLayout: "fixed" }}>
                <div className="tdAlignVC" style={{ display: "table-cell" }}>{t("1st")}</div>
                <div className="tdAlignVC" style={{ display: "table-cell" }}>{t("2nd")}</div>
                <div className="tdAlignVC" style={{ display: "table-cell" }}>{t("3rd")}</div>
                <div className="tdAlignVC" style={{ display: "table-cell" }}> 
                {lang.langCode == "en-us"? <>{t("Total")}<br />{t("Runs")}</>: <>{t("Runs")}<br />{t("Total")}</>} </div>
              </div>
            </td>

            {
              mockData?.RaceClassList?.map((race: any, i: number) => (
                <td key={`raceClass_thead_2_${i}`} className="R1 tdBgYellow">
                  {race.RaceClass}<br />
                  {race.Distance}{t("Meter")}<br />
                  {race.Track}<br />
                  {race.AbandonInd > 1 ?
                    <span dangerouslySetInnerHTML={{ __html: t("race_abandoned") }}></span>
                    : race.AbandonInd > 0 ? <span dangerouslySetInnerHTML={{ __html: t("race_voided") }}></span> : ""}
                </td>
              ))
            }
            {/* {raceMeetings.map((race: any, indx: any) => <td key={indx} className="R1 tdBgYellow">
              {race.claCode}<br />
              ({race.distance}){t("Meter")}<br />
              {lang?.langCode == "en-us" ? race.raceTrack.description_en : race.raceTrack.description_ch}<br />
              {renderStatus(race?.status)}
            </td>)
            } */}
          </tr>
        </thead>
        <tbody>
          {
            jockeyStat?.map((jockey: any, indx: any) => {

              return (<tr key={indx}>
                <td className="tdAlignC f_fs13">
                  <a href={`/${lang.langCode}/local/information/jockeyprofile?jockeyid=${jockey?.jockeyCode}`}>{jockey?.jockeyName}</a>
                </td>
                <td>
                  <div style={{ display: "table", width: "110px", tableLayout: "fixed" }}>
                    <div className="tdAlignVC" style={{ display: "table-cell" }}>{jockey?.ssnStat?.numFirst || 0}</div>
                    <div className="tdAlignVC" style={{ display: "table-cell" }}>{jockey?.ssnStat?.numSecond || 0}</div>
                    <div className="tdAlignVC" style={{ display: "table-cell" }}>{jockey?.ssnStat?.numThird || 0}</div>
                    <div className="tdAlignVC" style={{ display: "table-cell" }}>{jockey?.ssnStat?.numStarts || 0}</div>
                  </div>
                </td>
                {
                  data?.races?.map((race: any, indx2: any) => {
                    const runner = race?.runners.find((i: any) => i?.jockey?.code == jockey?.jockeyCode)

                    const changeJockey = data?.changeHistories?.find((x: any) => x.type == "99" && x.runnerNo == runner?.no && x.raceNo == race?.no && x.horseCode === runner?.horse?.code && x?.dueToPromotion == '0');
                    const hasMultis = jockey?.jockeyHorseList?.filter((i:any) => i.raceNo == race?.no).length > 1;
                    return <td key={indx2} className={!hasMultis && changeJockey ? "tdBgPurple" : ""}>
                      {
                        jockey?.jockeyHorseList?.map((horse: any, idx: any) => {
                          if (horse?.raceNo != race?.no) return null
                          if (hasMultis && horse?.status == "Scratched") return null

                          return horse?.status == "Scratched" ? <span key={idx} className="color_grey1">{t("SCR")}<br />{horse?.horseName}</span>
                            : <span key={idx}>
                              {
                                horse?.winOdds > 0 ?
                                <>
                                  <span className="color_red5">
                                    {horse?.winOdds}</span>
                                  <br />
                                </>
                                : null
                              }
                              
                              <a href={`/${lang.langCode}/local/information/horse?horseid=${horse.id}`}>{horse?.horseName}</a>
                            </span>
                        })
                      }
                    </td>
                  })
                }

              </tr>)
            })

          }
        </tbody>
      </table>
    )
  }

  const JKCScheduledRidesTable = () => {

    return (
      <table className="jkc_table titleHoverColorPurple table_bd f_tac f_fs13" style={{ width: "100%" }}>
        <thead>
          <tr className="bg_blue font_wb color_w">
            <td width="60" rowSpan={2}>{t("JKC")}<br />{t("no")}</td>
            <td width="80" rowSpan={2}>{t("jockey")}</td>
            {mockData?.Stage > 4 ? <td width="60" rowSpan={2}>{t("JKC")}<br />{t("points")}<br />{t("score")}</td> : null}
            {mockData?.Stage > 3 ? <td width="60" rowSpan={2}>{t("JKC")}<br />{t("odds")}</td> : null}

            {
              mockData?.RaceClassList?.map((race: any, i: number) => (
                <td key={`raceClass_thead_1_${i}`} style={{width: "auto"}} className={`tdRace ${race.RaceNo > mockData?.CurrentRaceNo ? "bg_blue" : "tdBgGrer"}`}>
                  {t("jkc_thead_race").replace("{0}", race.RaceNo.toString())}</td>
              ))
            }
          </tr>
          <tr className="tdBgYellow tdAlignC f_fs13">
            {
              mockData?.RaceClassList?.map((race: any, i: number) => (
                <td key={`raceClass_thead_2_${i}`} className={race.RaceNo > mockData?.CurrentRaceNo ? "tdBgYellow" : "tdBgGrer"}>
                  {race.RaceClass}<br />
                  {race.Distance}{t("Meter")}<br />
                  {race.Track}<br />
                  {race.AbandonInd > 1 ?
                    <span dangerouslySetInnerHTML={{ __html: t("race_abandoned") }}></span>
                    : race.AbandonInd > 0 ? <span dangerouslySetInnerHTML={{ __html: t("race_voided") }}></span> : ""}
                </td>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            mockData?.JockeysRidesList && mockData?.JockeysRidesList.length > 0 ?
              mockData?.JockeysRidesList?.filter((x: any) => x.Name != "" || x.SelNo == mockData?.OtherNo)?.map((jockey: any, index: number) => (
                (jockey.SelNo == mockData?.OtherNo && mockData?.OthersList.length > 0 )?
                  <>
                    <tr className="tdBgWhite tdAlignC f_fs13" key={`jockey_${jockey.Name}_${index}`}>
                      <td rowSpan={mockData?.OthersList.length + 1}>{mockData?.OtherNo}</td>
                      <td>{t("trainerRanking_other")}</td>
                      {mockData?.Stage > 4 ?
                        <td>{jockey.Points >= 0 ? jockey.Points : "---"}</td> : null
                      }

                      {mockData?.Stage > 3 ?
                        <td><span className="color_red5">{jockey.Odds > 0 ? jockey.Odds : "---"}</span></td> : null //CommonFormat.GetFixedOdds(Odds)
                      }
                      <td colSpan={mockData?.RaceClassList.length}></td>
                    </tr>
                    {
                      mockData?.OthersList.map((otherJockey: any, i: number) => (
                        <tr key={`otherJockey_${i}`}>
                          <td><a href={`/${lang.langCode}/local/information/jockeyprofile?jockeyid=${otherJockey.Id}`}>{otherJockey?.Name}</a></td>
                          {mockData?.Stage > 4 ?
                            <td>{otherJockey.Points >= 0 ? otherJockey.Points : "---"}</td> : null
                          }
                          {mockData?.Stage > 3 ? <td></td> : null}

                          {mockData?.RaceClassList?.map((race: any, ids: number) => (
                            otherJockey?.Starters?.filter((x: any) => x.RaceNo == race.RaceNo).length > 0 ?
                              handleTbodyStarters(otherJockey, race.RaceNo, ids)
                              : <td key={ids}></td>
                          ))
                          }
                        </tr>
                      ))
                    }
                  </>
                  : <>
                    <tr>
                      <td>{jockey.SelNo}</td>
                      <td><a href={`/${lang.langCode}/local/information/jockeyprofile?jockeyid=${jockey.Id}`}>{jockey.Name}</a></td>
                      {mockData?.Stage > 4 ?
                        <td>{jockey.Points >= 0 ? jockey.Points : "---"}</td> : null
                      }

                      {mockData?.Stage > 3 ?
                        <td><span className="color_red5">{jockey.Odds > 0 ? jockey.Odds : "---"}</span></td> : null //CommonFormat.GetFixedOdds(Odds)
                      }
                      {mockData?.RaceClassList?.map((race: any, ids: number) => (
                        jockey?.Starters?.filter((x: any) => x.RaceNo == race.RaceNo).length > 0 ?
                          handleTbodyStarters(jockey, race.RaceNo, ids)
                          : <td key={ids}></td>
                      ))
                      }
                    </tr>
                  </>

              ))
              : null
          }
        </tbody>
      </table>

    )
  }
  if (loading) return null;
  return (
    <>
        <div id='mainContainer'>
        <Header />
        <HeaderNav />
        {
            hasData == 2 ? <NoInformation ssn_end={true} type="noinfo" /> :
            (hasData == 3 || (stage < 3 && jockeyStat?.length == 0))? <NoInformation ssn_end={true} type="inforeleasedshortly" /> :
                
                ((jockeyStat && jockeyStat?.length > 0) || (mockData?.JockeysRidesList && mockData?.JockeysRidesList.length > 0)) ?
                    <div className="commContent jkcRides f_fs13">
                    <div className="commTitlePic">
                        <img src={`${assetPrefix}/images/title_ref_J_rides_list_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} />
                    </div>
                    <div className="date_title">
                        <div className="date_title f_tar">
                        {
                            mockData?.RaceHeaders?.map((mtg: any) => (
                            handleRaceHeader(mtg.Date, mtg.Venue)
                            ))
                        }
                        </div>
                    </div>
                    <div id="JKC">
                        <div className="data_tab performance f_fs13" id="JKC_info">
                        <div className={`data_title f_tar titleHoverColorPurple`}>
                            <u><a href={`/${lang.langCode}/local/info/jockeys-rides${`?racedate=${mockData?.NextMeetingDate?.replaceAll("-", "/")}`}`}>{t("jockeys_rides_for_the_day")}</a></u>
                        </div>
                        {
                            stage < 3 ?
                            <>
                                <div className="data_title f_clear">
                                <p className="f_fl" style={{ marginRight: "150px" }}>{t("race_meeting")} {handleDate(mockData?.NextMeetingDate, dateFormat.display.date)}</p>

                                {
                                    stage > 1 ?
                                    <p className={`f_fr nav titleHoverColorPurple`}>{t("last_update_time")} {getCurrentTimeFormatted()}<span><a style={{cursor: "pointer"}}  onClick={() => { window.location.href = window.location.href }}>{t("refresh")}</a></span></p>
                                    : <></>
                                }
                                </div>
                                <div className="data_title f_tar">
                                <span className="color_blue1">
                                    {handleJKCForTheDayStatus()}
                                </span>
                                </div>
                            </>
                            :
                            <>
                                <div className="data_title f_clear">
                                <p className="f_fl" style={{ marginRight: "50px" }}>{t("race_meeting")} {handleDate(mockData?.NextMeetingDate, dateFormat.display.date)}</p>
                                <p className="f_fl" style={{ marginRight: "100px" }}>{mockData?.PoolName}</p>
                                <p className="f_fl">
                                    {mockData?.Stage == 5 ?
                                    <img src={`${assetPrefix}/images/InPlay_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} style={{ width: "98px", height: "20px" }} alt="" />
                                    : null
                                    }
                                </p>
                                <p className="f_fr nav titleHoverColorPurple">
                                    {t("last_update_time")} {getCurrentTimeFormatted()}
                                    <span>
                                    <a style={{cursor: "pointer"}} onClick={() => { window.location.href = window.location.href }}>{t("refresh")}</a>
                                    </span>
                                </p>
                                </div>
                                <div className="data_title f_tar">
                                <span className="color_blue1">{handleStatus()} </span>
                                </div>
                                {mockData?.PoolRefund ?
                                <div className="rowDiv5">
                                    <span className="color_red">{t("poolrefund_note").replace("{0}", mockData?.PoolNumber)}</span>
                                </div> : null}
                            </>
                        }

                        {
                            stage < 3 ? JKCForTheDayTable() : JKCScheduledRidesTable()
                        }
                        </div>
                    </div>

                    {/* <p><span className="boldFont13 lineH18" style={{ backgroundColor: "#ffffff", color: "#000000" }}>&nbsp;</span></p> */}

                    {stage < 3 ?
                    <Remarks path="JockeysRides" customClass="jkc_remark" />
                    :
                    <Remarks path="JKCScheduledRides" customClass="jkc_remark" />
                    }
                    
                    </div>
                    : <NoInformation ssn_end={true} type="noinfo" />
        }
        </div>
      <Footer />
    </>
  );
};
export default JKCScheduledRides;